export default __webpack_public_path__ + "static/media/blog02.8a019e4f.png";